/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UsersDTO,
} from '../models/index';
import {
    UsersDTOFromJSON,
    UsersDTOToJSON,
} from '../models/index';

export interface UsersSuggestRequest {
    q: string;
}

/**
 * 
 */
export class SuggestApi extends runtime.BaseAPI {

    /**
     * Creates request options for usersSuggest without sending the request
     */
    async usersSuggestRequestOpts(requestParameters: UsersSuggestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling usersSuggest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/suggest/users`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async usersSuggestRaw(requestParameters: UsersSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UsersDTO>>> {
        const requestOptions = await this.usersSuggestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UsersDTOFromJSON));
    }

    /**
     */
    async usersSuggest(requestParameters: UsersSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UsersDTO>> {
        const response = await this.usersSuggestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
